import type { PropsWithChildren, ReactElement } from 'react';

import { Box, HStack, Text, VStack } from '@frontend/legacy-components';

import { FeatureFlagCategory } from 'modules/common/drawers/featureFlagDrawer/types';

import { TierAlignmentPopover } from './TierAlignmentPopover';

export type FormSectionProps = PropsWithChildren<{
  name: string | ReactElement;
  category: FeatureFlagCategory;
}>;

export const FormSection = ({ name, category, children }: FormSectionProps) => {
  const showPopover = category === FeatureFlagCategory.Entitlement;

  return (
    <VStack
      spacing={0}
      align="stretch"
      paddingBottom={2}
      borderWidth={0}
      borderBottomWidth={1}
      borderStyle="solid"
      borderColor="separator.divider"
      borderRadius="md"
      mx={-1}
      _last={{
        paddingBottom: 0,
        borderBottomWidth: 0,
      }}
    >
      <HStack
        spacing={0.75}
        position="sticky"
        top={0}
        bg="page.surface"
        zIndex={1}
        py={1}
        mb={0}
        px={1}
        alignItems="center"
      >
        <Text fontSize="lg" fontWeight="heavy">
          {name}
        </Text>
        {showPopover && <TierAlignmentPopover category={category} />}
      </HStack>
      <Box
        as="table"
        width="100%"
        sx={{
          tableLayout: 'fixed',
        }}
      >
        <Box as="thead">
          <Box as="tr" position="sticky" top={5} bg="page.surface" zIndex={2}>
            <Box as="th" textAlign="left" pl={1}>
              Title
            </Box>
            <Box as="th" textAlign="right" px={1} width="136px">
              Availability
            </Box>
            <Box as="th" textAlign="center" px={0.5} width="56px">
              Grow
            </Box>
            <Box as="th" textAlign="center" px={0.5} width="56px">
              Pro
            </Box>
            <Box as="th" textAlign="center" px={0.5} width="56px">
              Ent
            </Box>
            <Box as="th" textAlign="center" px={0.5} width="56px">
              Ent MS
            </Box>
            <Box as="th" textAlign="center" pr={1} width="80px">
              Value
            </Box>
          </Box>
        </Box>
        <Box as="tbody">{children}</Box>
      </Box>
    </VStack>
  );
};
